module.exports = __webpack_public_path__ + "img/banner.8cf01d9f.png";